module.exports = __webpack_public_path__ + "img/logo.652de91c.png";